<template>
  <store-recherche-provider
    key="compteFournisseur"
    :name="constantes.storeName"
    :copy="compteFournisseurStore"
    :isTemporary="true"
    :copyChanges="changesCompteFournisseurStore()">
    <m-compte-tiers
      :tiersId="fournisseur.id"
      :soldeTiersInfo="soldeFournisseurInfo"
      :tiersInformation="fournisseur"
      :soldeAtInfiniteDay="soldeAtInfiniteDay"
      :isFromDetailClient="false"
      :nameStore="constantes.storeName"
    />
  </store-recherche-provider>
</template>

<script>
import { getSolde } from '@/api/mouvementClient/index';
import * as allTypes from '@/store/mutation-type';
import compteFournisseurStore from '@/store/modules/compteClient';
import formatIsoDate from '@/services/general/formatIsoDate';
import genererCriteresRechercheCompteClient from '@/services/bodac/client/criteresRecherche/genererCriteresRechercheCompteClient';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import mCompteTiers from '@/components/tiers/m_CompteTiers';
import { INFINITE_DAY } from '@/configuration/general';

export default {
  props: {
    fournisseur: {
      required: true,
      type: Object,
    },
  },
  components: {
    mCompteTiers,
    storeRechercheProvider,
  },
  data() {
    return {
      soldeAtInfiniteDay: 0,
      soldeFournisseurInfo: 0,
      compteFournisseurStore,
      constantes: {
        storeName: 'compteClient',
      },
    };
  },
  methods: {
    async getSoldeAtInfiniteDay() {
      const param = {
        tiersId: this.fournisseur.id,
        date: formatIsoDate(INFINITE_DAY),
      };
      const responseSoldeFournisseur = await getSolde(param);
      this.soldeAtInfiniteDay = responseSoldeFournisseur.data.result;
    },
    async getSoldeFournisseur() {
      const param = {
        tiersId: this.fournisseur.id,
        date: formatIsoDate(new Date()),
      };
      const responseSoldeFournisseur = await getSolde(param);
      this.soldeFournisseurInfo = responseSoldeFournisseur.data.result;
    },
    changesCompteFournisseurStore() {
      const intitState = {
        items: [],
        total: 0,
        solde: 0,
        maxDatemouvement: null,
        critereRecherche: genererCriteresRechercheCompteClient(),
        lastPayload: {},
      };
      return {
        state: intitState,
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = intitState;
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  async mounted() {
    await this.getSoldeAtInfiniteDay();
    await this.getSoldeFournisseur();
  },
};
</script>
